import React, { useState } from "react";
import axios from "axios";
import { Col, Row, Card, Container, Form, Button } from '@themesberg/react-bootstrap';
import { GeneralInfoForm } from "../components/Forms";
import Layout from '../components/Layout';
import { BASE_URL } from "../constants";

const ProfileSettings = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userId = userData ? userData.id : null; // Get userId from parsed userData
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the userId is not found
    if (!userId) {
      setMessage("User ID not found.");
      return;
    }

    // Check if passwords match
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      const res = await axios.post(`${BASE_URL}/users//resetPasswordById`, {
        userId, 
        password, 
      });
      
      setMessage(res.data.message || "Password updated successfully");
      localStorage.removeItem("resetToken"); 
    } catch (error) {
      console.error(error);
      setMessage(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <Layout>
      <div className="container mt-5">
        <Row className="justify-content-center">
        <Col md={10} lg={8} xl={7} className="my-auto">
            <GeneralInfoForm />
          </Col>
          <Col>
          <Card className="shadow-lg border-0 rounded">
  <Card.Body className="p-4 p-md-6">
    <h3 className="text-center mb-4 text-primary">Reset password</h3>

    {message && <div className="alert alert-info">{message}</div>}

    <Form onSubmit={handleSubmit} className="mt-4">
      <Form.Group className="my-2" controlId="password">
        <Form.Label>Password</Form.Label>
        <Form.Control
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="my-2" controlId="confirmPassword">
        <Form.Label>Confirm Password</Form.Label>
        <Form.Control
          type="password"
          placeholder="Confirm password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </Form.Group>

      <div className="mt-3 d-flex justify-content-end">
<Button type='submit' variant='primary' size="sm">
                    Update
                  </Button>
                    </div>
    </Form>
  </Card.Body>
</Card>

          </Col> 
        </Row>
      </div>
    </Layout>
  );
};

export default ProfileSettings;
